export class ClipboardButton extends HTMLButtonElement {
	public static NAME = "clipboard-button";

	#message: HTMLElement | null = null;

	#showMessage = () => {
		if (this.#message) {
			return;
		}
		this.ariaDisabled = "true";
		this.#message = document.createElement("span");
		this.#message.setAttribute("role", "status");
		this.#message.setAttribute("aria-live", "polite");
		this.#message.classList.add(
			"absolute",
			"left-1/2",
			"bottom-full",
			"px-4",
			"py-2",
			"mb-5",
			"rounded-full",
			"text-white",
			"bg-black",
			"whitespace-nowrap",
			"pointer-events-none",
		);
		this.#message.textContent = this.dataset.copied || "Link copied";
		this.append(this.#message);

		this.#message
			.animate(
				[
					{
						opacity: 0,
						transform: "translate(-50%,100%)",
					},
					{
						opacity: 1,
						transform: "translate(-50%,0%)",
					},
				],
				{
					fill: "both",
					duration: 400,
					easing: "cubic-bezier(0.34, 1.56, 0.64, 1)",
				},
			)
			.finished.then(() => {
				this.#message!.animate(
					{
						opacity: 0,
						transform: "translate(-50%,100%)",
					},
					{
						fill: "both",
						duration: 400,
						delay: 2000,
						easing: "ease-in",
					},
				).finished.then(() => {
					this.#message!.remove();
					this.#message = null;
					this.ariaDisabled = "false";
				});
			});
	};

	#handleClick = () => {
		const url = this.dataset.url || window.location.href;
		navigator.clipboard
			.writeText(url)
			.then(() => {
				this.#showMessage();
			})
			.catch((err) => {
				console.error("Failed to copy link: ", err);
			});
	};

	connectedCallback(): void {
		if (!navigator.clipboard?.writeText) {
			this.remove();
		}

		this.addEventListener("click", this.#handleClick);
	}

	disconnectedCallback(): void {
		this.removeEventListener("click", this.#handleClick);
	}
}

customElements.define(ClipboardButton.NAME, ClipboardButton, {
	extends: "button",
});
